import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import TSLPage from "./pages/TSLPage";
import LegalPage from "./pages/LegalPage";

function App() {
  // Remove any external badges/watermarks
  useEffect(() => {
    const removeBadges = () => {
      // Remove elements containing "emergent" or "Made with"
      const selectors = [
        '[class*="emergent"]',
        '[id*="emergent"]',
        'a[href*="emergent"]',
        '[class*="badge"]',
        '[class*="watermark"]'
      ];
      
      selectors.forEach(selector => {
        document.querySelectorAll(selector).forEach(el => {
          if (el.textContent.toLowerCase().includes('emergent') || 
              el.textContent.toLowerCase().includes('made with')) {
            el.style.display = 'none';
            el.remove();
          }
        });
      });

      // Remove fixed position elements at bottom corners
      document.querySelectorAll('div, a, span').forEach(el => {
        const style = window.getComputedStyle(el);
        if (style.position === 'fixed' && 
            (style.bottom === '0px' || parseInt(style.bottom) < 50) &&
            (style.right === '0px' || parseInt(style.right) < 50)) {
          if (el.textContent.toLowerCase().includes('emergent') ||
              el.textContent.toLowerCase().includes('made with')) {
            el.style.display = 'none';
            el.remove();
          }
        }
      });
    };

    // Run immediately and after a delay
    removeBadges();
    const timer1 = setTimeout(removeBadges, 500);
    const timer2 = setTimeout(removeBadges, 1500);
    const timer3 = setTimeout(removeBadges, 3000);

    // MutationObserver to catch dynamically added elements
    const observer = new MutationObserver(removeBadges);
    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
      clearTimeout(timer3);
      observer.disconnect();
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<TSLPage />} />
          <Route path="/disclaimer" element={<LegalPage />} />
          <Route path="/privacy" element={<LegalPage />} />
          <Route path="/terms" element={<LegalPage />} />
          <Route path="/refunds" element={<LegalPage />} />
          <Route path="/unsubscribe" element={<LegalPage />} />
          <Route path="/antispam" element={<LegalPage />} />
          <Route path="/affiliate" element={<LegalPage />} />
          <Route path="/contact" element={<LegalPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;